/**
 * 現在のソート情報、次のソート対象より次のソート種類を取得する
 */
export var getNextOrder = function (key, sortCondition) {
    var orderSequence = ['asc', 'desc', 'none'];
    if (!sortCondition || key !== sortCondition.key) {
        return orderSequence[0];
    }
    var index = orderSequence.indexOf(sortCondition.order);
    if (index === -1) {
        return orderSequence[0];
    }
    return orderSequence[(index + 1) % orderSequence.length];
};
